import { MentionSuggestion } from "../../mentions";
import PropTypes from "prop-types";
import React from "react";
import { StandardMentionSuggestionItem } from "../..";

/**
 * @param {Boolean}           isSelected
 * @param {MentionSuggestion} suggestion
 * @param {Function}          acceptSuggestion
 */
export default function DisruptorSuggestionItem({ isSelected, suggestion, acceptSuggestion }) {
  const disruptor = suggestion.getOriginalData();

  return (
    <StandardMentionSuggestionItem isSelected={isSelected} suggestion={suggestion} acceptSuggestion={acceptSuggestion}>
      <div
        css={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <img
          src={disruptor.user.avatar}
          css={{
            marginRight: 15,
            borderRadius: "100%",
            border: "solid 2px #005aee",
            width: 40,
            height: 40,
          }}
        />

        <div>
          <div
            css={{
              fontSize: 14,
              color: isSelected ? "#ffffff" : "#212121",
            }}
          >
            {disruptor.user.fullName}
          </div>

          <div
            css={{
              fontSize: 12,
              color: isSelected ? "#ffffff" : "#797979",
            }}
          >
            {disruptor.user.jobTitle}, {disruptor.company.name}
          </div>
        </div>
      </div>
    </StandardMentionSuggestionItem>
  );
}

DisruptorSuggestionItem.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  suggestion: PropTypes.instanceOf(MentionSuggestion).isRequired,
  acceptSuggestion: PropTypes.func.isRequired,
};
